import React, { useCallback } from 'react'
import { useMuiSelectUtils } from 'scenes/Dashboard/components-next/Inputs/Select/Select.hook'
import { makeStyles } from 'tss-react/mui'

import { MenuItem, Select, SelectChangeEvent, Theme } from '@mui/material'

import { CorporateStatusFilter } from '../../duck/types'

export type CorporateStatusSelectorProps = {
  corporateStatus: CorporateStatusFilter
  onChange: (newSearch: CorporateStatusFilter) => void
}

export const CorporateStatusSelector = React.memo(({ onChange, corporateStatus }: CorporateStatusSelectorProps) => {
  const { classes } = useStyles()
  const menuItemsData = React.useMemo(
    () => [
      { value: CorporateStatusFilter.all, text: 'All' },
      { value: CorporateStatusFilter.active, text: 'Active' },
      { value: CorporateStatusFilter.inactive, text: 'Inactive' },
    ],
    []
  )
  const { getItem, selectedItem, setSelectedItem } = useMuiSelectUtils(menuItemsData, corporateStatus)

  const onSelectChange = useCallback(
    (event: SelectChangeEvent<{ name?: string; value: unknown }>) => {
      const corporateStatus = event.target.value as CorporateStatusFilter
      onChange(corporateStatus)
      setSelectedItem(corporateStatus)
    },
    [onChange]
  )

  return (
    <Select
      variant="standard"
      className={classes.field}
      onChange={onSelectChange}
      value={getItem(selectedItem)}
      renderValue={() => getItem(selectedItem)?.text}
    >
      {menuItemsData.map((m) => (
        <MenuItem key={m.value} value={m.value}>
          {m.text}
        </MenuItem>
      ))}
    </Select>
  )
})

CorporateStatusSelector.displayName = 'CorporateStatusSelector'

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  field: {
    marginLeft: spacing(2),
  },
}))
